















































import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { ZenObjectTable, ZenEllipsis } from 'zenComponents';
import ZenButton from '@reciprocity/button';
import { CalculationMethod } from '../types';

export default Vue.extend({
  name: 'ContentTab',
  components: {
    ZenObjectTable,
    ZenEllipsis,
    ZenButton,
  },
  data() {
    return {
      columns: [{ key: 'row-select', label: '' }, 'title', 'description'],
      data: [],
      loading: <boolean>true,
      addingCalcuationMethod: false,
      calculationMethodChanged: false,
      selectedCalculationMethod: null,
    };
  },
  computed: {
    ...mapGetters(['routes']),
  },
  watch: {
    selectedCalculationMethod() {
      this.calculationMethodChanged = true;
    },
  },
  async created() {
    try {
      this.data = await this.request({
        route: 'riskCalculations',
        defaultErrorHandler: false,
      });
    } catch (e) {
      this.showAlert({
        type: 'error',
        message: 'Failed to load Calculation Methods',
      });
    } finally {
      this.loading = false;
      this.$emit('loaded');
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'alerts/show',
      showModal: 'modals/show',
      request: 'request',
    }),
    async showCalculationMethodDetail(item: CalculationMethod) {
      try {
        await this.showModal({
          type: 'RiskCalculationMethod',
          data: {
            title: item.title,
            url: item.url,
          },
        });
      } catch (e) {
        // User closed modal
      }
    },
    async addCalculationMethod() {
      const isConfirmed = await this.confirmCalculationMethodAdding();
      if (isConfirmed) {
        this.addingCalcuationMethod = true;
        try {
          const url = this.routes.riskAddCalculation.replace('__CALCULATION_ID__', this.selectedCalculationMethod);
          const resp = await this.request({
            method: 'post',
            url,
          });
          if (resp.created > 0) {
            this.showAlert({
              type: 'success',
              message: `${resp.title} has been added. ${resp.created} Risk Elements created.`,
            });
            this.$emit('refreshTabs', ['factors', 'vectors', 'scores']);
          } else {
            this.showAlert({
              type: 'warning',
              message: `${resp.title} was already added.`,
            });
          }
        } catch (error) {
          // Error caught in request
        }
        this.addingCalcuationMethod = false;
      }
    },
    async confirmCalculationMethodAdding() {
      let isConfirmed = false;
      try {
        isConfirmed = await this.showModal({
          type: 'GenericConfirm',
          data: {
            title: 'Confirm changes',
            okTitle: 'Add',
            message: 'The selected Calculation Method will be added.',
          },
        });
      } catch (e) {
        // User closed modal
      }
      return isConfirmed;
    },
  },
});
